import { styled } from "@mui/material";
import { useEnvironment } from "@keycloak/keycloak-ui-shared";
import { Environment } from "../../environment";

type IconMapperProps = {
  icon: string;
  folderName: string;
  format?: 'svg' | 'png';
};

const Image = styled('img')(() => ({
  display: 'block'
}));

export const IconMapper = ({ icon, folderName, format = 'svg' }: IconMapperProps) => {
  const { environment } = useEnvironment<Environment>();
  const resolvedIcon = icon === 'epam-microsoft-second' ? 'epam-microsoft' : icon;
  
  return (
    <Image alt={icon} src={`${environment.resourceUrl}/images/${folderName}/${resolvedIcon}.${format}`} />
  );
};
